import * as THREE from 'three'

import scanVertexShader from './shaders/scan.vertex.glsl'
import scanFragmentShader from './shaders/scan.fragment.glsl'

export default class ScanModel
{
    /**
     * Constructor
     */
    constructor(_options)
    {
        // Options
        this.camera = _options.camera
        this.sizes = _options.sizes
        this.time = _options.time
        this.geometry = _options.geometry
        this.revealPosition = _options.revealPosition
        this.color = _options.color

        // Container
        this.container = new THREE.Object3D()

        // Material
        this.material = new THREE.ShaderMaterial({
            wireframe: false,
            transparent: true,
            flatShading: true,
            depthTest: true,
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            uniforms:
            {
                uTime: { value: 0 },

                uColor: { value: new THREE.Vector3(this.color.x, this.color.y, this.color.z) },

                uRevealPosition: { value: new THREE.Vector3(this.revealPosition.x, this.revealPosition.y, this.revealPosition.z) },
                uRevealDistance: { value: 0 },

                uAlpha: { value: 1 },

                uFluctuationFrequency: { value: 0.001 },
                uFluctuationAmplitude: { value: 40.0 }
            },
            vertexShader: scanVertexShader,
            fragmentShader: scanFragmentShader
        })

        // Mesh
        this.mesh = new THREE.LineSegments(this.geometry, this.material)
        this.container.add(this.mesh)

        // Time tick
        this.time.on('tick', () =>
        {
            this.material.uniforms.uTime.value = this.time.elapsed
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/ScanModel.js